// extracted by mini-css-extract-plugin
module.exports = {"subheaderColor":"rgba(43,19,17,0.4)","obblack":"rgba(43,19,17,0.4)","orange":"#FF7034","bblack":"#2b2523"};